import { useRef, useState, useEffect } from "react";
import { useAtom } from "jotai";

import {
  body,
  bodyExpand,
  expandButton,
  expandButtonExpand,
  expandIcon,
  shrinkIcon,
  closeIcon,
  buttonWrap,
  buttonWrapExpand,
  callDownIcon,
  operateButton,
  operateButtonExpand,
} from "./style";
import { CameraButton } from "components/CameraButton";
import { MicButton } from "components/MicButton";
import { MyVideo } from "components/MyVideo";
import { OperatorVideo } from "components/OperatorVideo/NewOperatorVideo";
import { SettingButton } from "components/SettingButton";
import { Spacer } from "components/Spacer";
import { H5 } from "components/Typography/H5";
import { Icon } from "icons/Icon";
import { CallDisplayTypes, myVideoHandler, OperatorVideoHandler } from "types";
import { wsStatusAtom, myCameraAtom } from "states";
import { Color } from "utils/variables";

export const CallDisplay = ({ onClose }: CallDisplayTypes) => {
  const [isExpand, setIsExpand] = useState<boolean>(false);
  const [onMic, setMic] = useState<boolean>(true);
  const [onCamera, setCamera] = useAtom(myCameraAtom);
  const [isOperatorFront, setIsOperatorFront] = useState<boolean>(true);
  const [wsStatus] = useAtom(wsStatusAtom);
  const myVideoRef = useRef<myVideoHandler>(null);
  const operatorVideoRef = useRef<OperatorVideoHandler>(null);

  // 2回目以降の通話のためカメラの状態を初期化
  useEffect(() => {
    setCamera(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleExpand = () => {
    setIsExpand(!isExpand);
  };
  const handleFront = () => {
    setIsOperatorFront(!isOperatorFront);
  };

  return (
    <div className={`${body} ${isExpand ? bodyExpand : ""}`}>
      <div
        className={`${expandButton} ${isExpand ? expandButtonExpand : ""}`}
        onClick={() => handleExpand()}
      >
        {!isExpand && <Icon name="Expand" size={25} className={expandIcon} />}
        {isExpand && <Icon name="Shrink" size={25} className={shrinkIcon} />}
      </div>
      <MyVideo
        ref={myVideoRef}
        isExpand={isExpand}
        isFront={!isOperatorFront}
        handleParentMic={(value: boolean) => setMic(value)}
        handleParentCamera={(value: boolean) => setCamera(value)}
        handleFront={() => handleFront()}
      />

      <OperatorVideo
        ref={operatorVideoRef}
        isExpand={isExpand}
        isFront={isOperatorFront}
        handleFront={() => handleFront()}
      />

      <div className={`${buttonWrap} ${isExpand ? buttonWrapExpand : ""}`}>
        {isExpand && (
          <SettingButton
            onClick={() => myVideoRef?.current?.openSettingModal()}
          />
        )}
        {(wsStatus === "closed" || wsStatus === "connected") && (
          <div
            className={`${operateButton} ${
              isExpand ? operateButtonExpand : ""
            }`}
            onClick={() => onClose()}
          >
            <Icon name="Close" size={12} className={closeIcon} />
            <Spacer size={10} />
            <H5 color={Color.LightBlack}>閉じる</H5>
          </div>
        )}
        {(wsStatus === "matching" || wsStatus === "matched") && (
          <div
            className={`${operateButton} ${
              isExpand ? operateButtonExpand : ""
            }`}
            onClick={() => operatorVideoRef?.current?.callCancel()}
          >
            <Icon name="CallDown" size={12} className={callDownIcon} />
            <Spacer size={4} />
            <H5 color={Color.BrightOrange}>キャンセル</H5>
          </div>
        )}
        {wsStatus === "calling" && (
          <div
            className={`${operateButton} ${
              isExpand ? operateButtonExpand : ""
            }`}
            onClick={() => operatorVideoRef?.current?.callFinishModal()}
          >
            <Icon name="CallDown" size={12} className={callDownIcon} />
            <Spacer size={4} />
            <H5 color={Color.BrightOrange}>通話を終了</H5>
          </div>
        )}
        {isExpand && (
          <>
            <MicButton
              onClick={() => myVideoRef?.current?.handleMicMode()}
              on={onMic}
            />
            <Spacer size={18} />
            <CameraButton
              onClick={() => myVideoRef?.current?.handleCameraMode()}
              on={onCamera}
            />
          </>
        )}
      </div>
    </div>
  );
};
